<template>
  <div class="shop-management-container">
    <v-data-table
      :loading="isLoading"
      :headers="headers"
      :items="(shops && shops.data) || []"
      :server-items-length="shops && shops.total"
      :footer-props="{
        itemsPerPageOptions,
      }"
      :options.sync="options"
      no-data-text="ไม่พบข้อมูล"
      no-results-text="ไม่พบข้อมูล"
    >
      <template v-slot:top>
        <v-toolbar flat color="white" :height="checkScreen">
          <v-row class="align-center">
            <v-col cols="6" sm="5" lg="7">
              <h1>ข้อมูลร้านค้า</h1>
            </v-col>
            <v-col cols="6" sm="3" lg="2" class="text-right pr-sm-0">
              <v-btn color="#f7941e" @click="createShop">
                <v-icon small class="mr-1">mdi-plus</v-icon>สร้างร้านค้า
              </v-btn>
            </v-col>
            <v-col cols="12" sm="4" lg="3">
              <v-text-field
                v-model="keyword"
                outlined
                dense
                hide-details
                label="Search"
                append-icon="mdi-magnify"
              />
            </v-col>
          </v-row>
        </v-toolbar>
      </template>
      <!-- <template v-slot:item.categories="{ item }">
        <span v-for="(i, index) in item.categories" :key="index">
          <span v-if="index > 0 && index < item.categories.length">, </span
          >{{ i.name }}
        </span>
      </template> -->
      <template v-slot:item.edit="{ item }">
        <v-btn data-testid="edit-shop-btn" class="action-button" depressed small @click="editItem(item)">
          <v-icon small>mdi-pencil</v-icon>
        </v-btn>
      </template>
      <template v-slot:item.delete="{ item }">
        <v-btn data-testid="delete-shop-btn" class="action-button" depressed small @click="deleteItem(item)">
          <v-icon small>mdi-trash-can-outline</v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <ConfirmModal v-model="conf.status" :data="conf" @confirm="deleteData" />
  </div>
</template>

<script>
import Utils from "@/mixin";
import { itemsPerPageOptions } from "@/plugins/common";

import ConfirmModal from "@/components/ConfirmModal";

export default {
  mixins: [Utils],
  components: {
    ConfirmModal,
  },
  computed: {
    checkScreen() {
      const { windowWidth } = this;
      if (windowWidth >= 960) {
        return "64px";
      }
      return "148px";
    },
  },
  mounted() {
    window.addEventListener("resize", () => {
      this.windowWidth = window.innerWidth;
    });
    this.itemsPerPageOptions = itemsPerPageOptions;
  },
  data: () => ({
    keyword: "",
    options: {
      itemsPerPage: 50,
    },
    itemsPerPageOptions: [],
    headers: [
      { text: "รหัสร้านค้า", value: "code", align: "center" },
      { text: "ชื่อร้านค้า", value: "name" },
      { text: "เบอร์โทรศัพท์", value: "phoneNumber" },
      { text: "ชั้น", value: "floor", sortable: false },
      { text: "พื้นที่", value: "areaSize", sortable: false },
      // { text: "หมวด", value: "categories", sortable: false },
      { text: "ประเภท", value: "type.name", sortable: false },
      { text: "แก้ไข", value: "edit", sortable: false, align: "center" },
      { text: "ลบ", value: "delete", sortable: false, align: "center" },
    ],
    conf: {
      status: false,
    },
    windowWidth: window.innerWidth,
  }),
  methods: {
    async getInitialData() {
      let condition = {};

      // filter
      if (this.keyword) {
        condition.query = this.keyword;
      }

      // paging
      {
        // Per page
        if (this.options && this.options.itemsPerPage) {
          condition.limit = this.options.itemsPerPage;
        }

        // Page
        if (this.options && this.options.page) {
          condition.page = this.options.page;
        }
      }

      // sort
      if (this.options?.sortBy?.[0]) {
        condition.order = `${this.options.sortBy[0]}:${
          this.options?.sortDesc?.[0] ? "desc" : "asc"
        }`;
      }

      // show all
      if (this.options && this.options.itemsPerPage<0) {
        condition.listType = "all"
      }

      await this.getShops(condition);
    },
    createShop() {
      this.$router.push({
        name: "Shop-Editor",
        params: { createShop: true },
      });
    },
    editItem(item) {
      this.$router.push({
        name: "Shop-Editor",
        params: { shop: item },
      });
    },
    deleteItem(data) {
      this.conf = {
        ...this.conf,
        text: `ร้านค้า: ${data?.name}`,
        status: true,
        data,
      };
    },
    async deleteData(value = false) {
      if (value) {
        await this.deleteShops({ id: this.conf?.data?.id });
      }
      this.conf = {
        ...this.conf,
        status: false,
        data: undefined,
      };
    },
  },
  watch: {
    options: {
      handler() {
        this.getInitialData();
      },
      deep: false,
    },
    keyword: {
      handler() {
        this.getInitialData();
      },
      deep: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.shop-management-container {
  padding: 40px 65px;
  .action-button {
    min-width: 28px;
    padding: 0;
  }
}
</style>